// extracted by css-extract-rspack-plugin
export default {"Root":"SearchResults-module__Root___mJ125"};